module.exports = new __parcel__URL__("aboutAlign.d9d43638.png").toString();